module.exports = __webpack_public_path__ + "img/logo-dark.620d7898.png";